import StorageHelper from 'Stores/helper';
import { union as _union, forEach as _each, keys as _keys, indexOf as _index } from 'lodash';

const scope = 'CAMPAIGNS/tracking';

const mod = {
  namespaced: true,
  state: {
    firedPixels: {},
  },
  mutations: {
    firedPixels: (state, firedPixelsObject) => {
      _union(_keys(state.firedPixels), _keys(firedPixelsObject)).forEach((pixelType) => {
        let stateIds = state.firedPixels[pixelType] || [],
            firedIds = firedPixelsObject[pixelType] || [];

        state.firedPixels[pixelType] = _union(stateIds, firedIds);
      });
    }
  },
  actions: {
    firedPixels({ commit, state }, firedPixelsObject) {

      commit('firedPixels', firedPixelsObject)

      StorageHelper.setLocalStorageVar(null, state.firedPixels, 'firedPixels', scope);

      // maintain compatibility with the classic campaign pixel fired entries
      const classicPixels = {
        facebook: 'fbPixelFired',
        twitter: 'twitterPixelFired',
        google: 'googlePixelFired',
        doubleClick: 'doubleclickPixelFired',
      };

      _keys(firedPixelsObject).forEach((pixelType) => {
        const campaignIds = firedPixelsObject[pixelType],
              classicPixel = classicPixels[pixelType];

        _each(campaignIds, id => {
          StorageHelper.setScopedVar(`${classicPixel}_${id}`, true);
        });
      });
    }
  },
  getters: {
    firedPixels(state) {
      return (pixelType) => {
        return state.firedPixels[pixelType] || [];
      }
    },
    campaignPixelFired(state, getters) {
      return (pixelType, campaignId) => {
        return _index(getters.firedPixels(pixelType), campaignId) !== -1;
      }
    }
  },
};

export default mod;
